import $ from 'jquery';
import {standardAjaxPost} from 'stdjs/standard-ajax';

$(document).ready(function(){

    document.addEventListener("basecoat:sidebar:change", (e) => {
        
        e.preventDefault();
        if (e.detail.open){
            var data = { "SIZE_MODE" : "EXPANDED" };
            $("#MAIN_CONTENT").removeClass("menu-closed");
            $("#MAIN_CONTENT").addClass("menu-open");
        } else {
            var data = { "SIZE_MODE" : "COLLAPSED" };
            $("#MAIN_CONTENT").removeClass("menu-open");
            $("#MAIN_CONTENT").addClass("menu-closed");
        }
        
        standardAjaxPost( toggleSidebarNavUrl, data, null, null, false );
        return false;
    });

    $(".sidenav-item-top").click(function(e){
        e.preventDefault();

        var sidenav = $(this).closest(".sidenav");
        var parent = $(this).closest(".sidenav-item");
        var children = parent.find(".sidenav-children");

        sidenav.removeClass("collapsed")

        if (children.height() > 0){
            children.height(0);
        } else {
            children.height(children.find(".sidenav-children-innner").height());
        }
        
        return false;
    });

});
